import { t } from '@ankr.com/common';
import { Timeframe } from '@ankr.com/chains-list';

export const getLabelByTimeframe = (timeframe: Timeframe) => {
  switch (timeframe) {
    case Timeframe.Hour:
      return t('chains.timeframes.hour');

    case Timeframe.Day:
      return t('chains.timeframes.day');

    case Timeframe.Week:
      return t('chains.timeframes.week');

    case Timeframe.Month:
      return t('chains.timeframes.month');

    default:
      return '';
  }
};
